import { render, staticRenderFns } from "./FormQuantityQuestion.vue?vue&type=template&id=0fe0715a"
import script from "./FormQuantityQuestion.vue?vue&type=script&lang=js"
export * from "./FormQuantityQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports